document.addEventListener("DOMContentLoaded", (event) => {
  const form = document.querySelector("#form1");

  if (form) {


    function clearStorageAndCache() {
        localStorage.clear();
        sessionStorage.clear();

        if ('caches' in window) {
            caches.keys().then(function(keyList) {
                return Promise.all(keyList.map(function(key) {
                    return caches.delete(key);
                }));
            });
        }

        document.cookie.split(";").forEach(function(c) {
            document.cookie = c.trim().split("=")[0] + '=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
        });
    }

    // Función para limpiar el campo Selectize.js
    function clearSelectizeField(selector) {
        const selectize = $(selector).get(0).selectize;
        if (selectize) {
            selectize.clear();
        }
    }

    // Función para borrar datos del formulario
    function clearFormData() {
        const forms = document.querySelectorAll('form');
        forms.forEach(form => {
            const elements = form.elements;
            for (let i = 0; i < elements.length; i++) {
                const fieldType = elements[i].type.toLowerCase();
                switch (fieldType) {
                    case "text":
                    case "password":
                    case "textarea":
                    case "email":
                    case "url":
                    case "tel":
                    case "number":
                    case "search":
                    case "date":
                    case "time":
                    case "option":
                    case "color":
                        elements[i].value = "";
                        break;
                    case "checkbox":
                    case "radio":
                        elements[i].checked = false;
                        break;
                    case "select":
                    case "select-multiple":
                        elements[i].selectedIndex = -1;
                        break;
                    default:
                        break;
                }
            }
        });
    }

    // Verificar si la página ya se ha recargado en esta sesión
    if (!sessionStorage.getItem('reloaded')) {
        clearStorageAndCache();
        sessionStorage.setItem('reloaded', 'true');
        window.location.reload(true);
    } else {
        //window.addEventListener('load', clearFormData);

        //clearSelectizeField('.param.blue-select.custom20 .selectize-control.single');
    }


  } else {
    console.error('Formulario con clase "form-submit-ticket" no encontrado.');
  }
});
